import millify from "millify";
import {
  FacebookIcon,
  GoogleIcon,
  InstagramIcon,
  MetaIcon,
  TikTokIcon,
} from "../components/Icons";
import { SelectOptionType } from "../types/forms";
import routeConstants from "./routeConstants";

export const DATE_FORMAT = "yyyy-MM-dd";
export const DATE_PICKER_FORMAT = "yyyy/MM/dd";

export enum CampaignsFilterEnum {
  dataSource = "dataSource",
  startDate = "startDate",
  endDate = "endDate",
  search = "search",
  status = "status",
}

export const dateFilterOptions: SelectOptionType[] = [
  {
    label: "Last 30 days",
    value: "Last 30 days",
  },
  {
    label: "Last 15 days",
    value: "Last 15 days",
  },
  {
    label: "Last 7 days",
    value: "Last 7 days",
  },
];

export const sortByFilterOptions: SelectOptionType[] = [
  {
    label: "ASC by Spend",
    value: "sort_by_spend_asc",
  },
  {
    label: "DESC by Spend",
    value: "sort_by_spend_desc",
  },
  {
    label: "ASC by Conversions",
    value: "sort_by_conversion_asc",
  },
  {
    label: "DESC by Conversions",
    value: "sort_by_conversion_desc",
  },
  {
    label: "ASC by Cost Per Conversion",
    value: "sort_by_spend_per_conversion_asc",
  },
  {
    label: "DESC by Cost Per Conversion",
    value: "sort_by_spend_per_conversion_desc",
  },
];

export const spendFilterOptions: SelectOptionType[] = [
    {
        label: "Ad Spend",
        value: "0",
    },
    {
        label: "$0-$100",
        value: "1",
    },
    {
        label: "$100-$500",
        value: "2",
    },
    {
        label: "$500-$1,000",
        value: "3",
    },
    {
        label: "$1,000-$5000",
        value: "4",
    },
    {
        label: "$5000-$10,000",
        value: "5",
    },
    {
        label: "$10,000+",
        value: "6",
    },
];


export const conversionFilterOptions: SelectOptionType[] = [
  {
    label: "All Conversions",
    value: "0",
  },
  {
    label: "Show converted ads",
    value: "1",
  },
  {
    label: "Show ads without conversions",
    value: "2",
  }
];

export const statusFilterOptions: SelectOptionType[] = [
  {
    label: "New",
    value: "New",
  },
  {
    label: "Contact attempted",
    value: "Contact attempted",
  },
  {
    label: "Disqualified",
    value: "Disqualified",
  },
  {
    label: "Not interested",
    value: "Not interested",
  },
  {
    label: "Pending",
    value: "Pending",
  },
  {
    label: "Scheduled",
    value: "Scheduled",
  },
  {
    label: "Screened",
    value: "Screened",
  },
  {
    label: "Screen failed",
    value: "Screen failed",
  },
  {
    label: "Consented",
    value: "Consented",
  },
  {
    label: "Withdrawn",
    value: "Withdrawn",
  },
  {
    label: "Randomized",
    value: "Randomized",
  },
];

export const creativeTypeFilterOptions: SelectOptionType[] = [
  {
    label: "Video",
    value: "Video",
  },
  {
    label: "Image",
    value: "Image",
  },
];

export const conditionFilterOptions: SelectOptionType[] = [
  {
    label: "Enable",
    value: "Enable",
  },
  {
    label: "Disable",
    value: "Disable",
  },
];

export const platformFilterOptions: SelectOptionType[] = [
  {
    label: "Google",
    value: "Google",
  },
  {
    label: "Facebook",
    value: "Facebook",
  },
];

export type AccordianPlatformType =
  | "google"
  | "facebook"
  | "instagram"
  | "tiktok";

export const adCopiesAccordian = {
  google: GoogleIcon(),
  facebook: FacebookIcon(),
  instagram: InstagramIcon(),
  tiktok: TikTokIcon(),
};

// constants/breadcrumbMap.ts
export const breadcrumbMap: Record<
  string,
  {
    parent: string;
    parentPath?: string;
    child?: string;
    dynamicChild?: boolean;
    subChild?: boolean;
  }
> = {
  [routeConstants.dashboard]: { parent: "Dashboard" },
  [routeConstants.myProfile]: { parent: "My Profile" },
  [routeConstants.campaigns]: { parent: "Campaigns" },
  [routeConstants.manageDataSource]: { parent: "Manage Data Source" },
  [routeConstants.reports]: { parent: "Reports" },
  [routeConstants.generatedReport]: {
    parent: "Reports",
    child: "Generated Report",
    parentPath: routeConstants.reports,
  },
  [routeConstants.topRecommendedDetailsReport]: {
    parent: "Top Recommended Reports",
    parentPath: routeConstants.reports,
    dynamicChild: true,
  },
  [routeConstants.generateReports]: {
    parentPath: routeConstants.reports,
    parent: "Reports",
    child: "Generate Report",
  },
  [routeConstants.conversions]: {
    parent: "Sign Up Form",
    parentPath: routeConstants.conversions,
  },
  [routeConstants.conversionsAddForm]: {
    parent: "Sign Up Form",
    parentPath: routeConstants.conversions,
    child: "Add",
  },
  [routeConstants.conversionsUpdateForm]: {
    parent: "Sign Up Form",
    parentPath: routeConstants.conversions,
    child: "Edit",
  },
  [routeConstants.conversionAccountDetails]: {
    parent: "Sign Up Form",
    parentPath: routeConstants.conversions,
    dynamicChild: true,
  },
  [routeConstants.conversionDetails]: {
    parent: "Sign Up Form",
    parentPath: routeConstants.conversions,
    child: "Details",
    dynamicChild: true,
    subChild: true,
  },
  [routeConstants.campaignDetails]: {
    parent: "Campaigns",
    parentPath: routeConstants.campaigns,
    dynamicChild: true,
  },
  [routeConstants.adCopies]: { parent: "Ad Creatives" },
  [routeConstants.learnAboutTrialPartners]: {
    parent: "Learn about Trial Partners",
  },
  [routeConstants.sendFeedback]: { parent: "Send Feedback" },
  // [routeConstants.aboutUs]: { parent: "About Us" },
  // [routeConstants.privacyPolicy]: { parent: "Privacy Policy" },
};

export const addFormTrackingURL = [
  {
    label: "Meta",
    icon: <MetaIcon />,
    url: `ad_id={{ad.id}}&adset_id={{adset.id}}&campaign_id={{campaign.id}}&ad_name={{ad.name}}&adset_name={{adset.name}}&campaign_name={{campaign.name}}`,
  },
  {
    label: "Google",
    icon: <GoogleIcon />,
    url: `ad_id={creative}&adset_id={adgroupid}&campaign_id={campaignid}&keyword={keyword}&match_type={matchtype}&placement={placement}`,
  },
  {
    label: "TikTok",
    icon: <TikTokIcon />,
    url: `ad_id=__CID__&adset_id=__AID__&campaign_id=__CAMPAIGN_ID__&ad_name=__CID_NAME__&adset_name=__AID_NAME__&campaign_name=__CAMPAIGN_NAME__`,
  },
];

export const METRICS_NAME: Record<string, string> = {
  cost_per_conversion: "Cost Per Conversion",
  all_conversions: "Conversion Value",
  average_cpc: "Average CPC",
  average_cpe: "Average CPE",
  average_cpm: "CPM (Cost Per 1000 Impressions)",
  average_cpv: "Average CPV",
  clicks: "Clicks",
  conversions: "Conversions",
  cost_micros: "Cost Micros",
  impressions: "Impressions",
  interactions: "Interactions",
  roas: "ROAS",
  spend: "Spend",
  ctr: "CTR",
  views: "Views",
};

export const formatMetricData = (
  key: string,
  value: string | number,
  isMilifyFormat = false
): string => {
  const removeTotalString = key?.replaceAll("total_", "");
  const symbol = METRIC_SYMBOLS[removeTotalString] ?? "";

  const formattedValue = Number(value).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  // If symbol is "$" → prefix
  if (symbol === "$") {
    return `${symbol}${formattedValue}`;
  }

  // If symbol is "%" → suffix
  if (symbol === "%") {
    return `${formattedValue}${symbol}`;
  }

  // Otherwise → just value
  return isMilifyFormat ? millify(Number(value)) : formattedValue;
};

export const METRIC_SYMBOLS: Record<string, string> = {
  all_conversions: "$",
  cost_per_conversion: "$",
  average_cpc: "$",
  average_cpe: "$",
  average_cpm: "$",
  average_cpv: "$",
  clicks: "",
  conversions: "",
  cost_micros: "$",
  impressions: "",
  interactions: "",
  roas: "$",
  spend: "$",
  ctr: "%",
};
